import React, { Fragment, Component } from 'react';
import { groupBy } from 'lodash';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Label, Button, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import { gql } from 'apollo-boost';
import { Mutation, Query } from 'react-apollo';
import { Formik } from 'formik';
import Loader from '~/components/loader/loader';
import FormikInputField from '~/components/formikInputField/formikInputField';
import SubmissionButton from '~/components/submissionButton/submissionButton';
import TransferScheduleOptions from '~/containers/transferScheduleOptions/transferScheduleOptions';

export const addLotsToExistingConsolidatedLotMutation = gql`
  mutation addLotsToExistingConsolidatedLot(
    $breweryId: Int!
    $lotIds: [Int]!
    $lotTransferIds: [Int]
    $consolidatedLotId: Int!
  ) {
    addLotsToExistingConsolidatedLot(
      breweryId: $breweryId
      lotIds: $lotIds
      lotTransferIds: $lotTransferIds
      consolidatedLotId: $consolidatedLotId
    ) {
      id
      reference
    }
  }
`;

export const transferLotsToNewConsolidatedLot = gql`
  mutation transferLotsToNewConsolidatedLot(
    $breweryId: Int!
    $lotIds: [Int]!
    $lotTransferIds: [Int]
    $tankId: Int!
    $transferScheduleId: Int!
  ) {
    transferLotsToNewConsolidatedLot(
      breweryId: $breweryId
      lotIds: $lotIds
      lotTransferIds: $lotTransferIds
      tankId: $tankId
      transferScheduleId: $transferScheduleId
    ) {
      id
      reference
    }
  }
`;

export const getLotsAndUniTanks = gql`
  query lotsAndUniTanks($breweryId: Int!, $productId: Int, $isConsolidated: Boolean) {
    lots(breweryId: $breweryId, status: "IN_PROGRESS", productId: $productId, isConsolidated: $isConsolidated) {
      id
      reference
      productId
    }
    tanks(breweryId: $breweryId, type: UNI_TANK, status: EMPTY) {
      id
      name
      volume
    }
  }
`;

export const transferToNewConsolidatedLot = gql`
  mutation transferToNewConsolidatedLot(
    $breweryId: Int!
    $lotIds: [Int]!
    $lotTransferIds: [Int]
    $tankId: Int!
    $transferScheduleId: Int
  ) {
    transferToNewConsolidatedLot(
      breweryId: $breweryId
      lotIds: $lotIds
      lotTransferIds: $lotTransferIds
      tankId: $tankId
      transferScheduleId: $transferScheduleId
    ) {
      id
      referene
    }
  }
`;

export class UseExistingConsolidatedLotForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false
    };
  }

  setSubmitting = submitting => {
    this.setState({
      submitting
    });
  };

  setError = error => {
    this.setState({
      error
    });
  };

  render() {
    const { onSuccess, values, brewery, firstLotProduct, lots, lotTransfers, onToggle, refetchQueries } = this.props;
    const { submitting } = this.state;
    return (
      <Mutation mutation={addLotsToExistingConsolidatedLotMutation}>
        {addToExistingConsolidatedLot => (
          <Fragment>
            <ModalBody>
              <div>
                <p>
                  There is an existing consolidated lot containing <em>{firstLotProduct.lot.product.name}</em>. This
                  will add these lots to the consolidated lot:
                </p>
                <div className="mb3 pt2 pb3 bb-divider">
                  {lotTransfers.map(t => (
                    <h4 className="mv0 mb2 f5">{t.lot.reference}</h4>
                  ))}
                </div>
                <Label>Consolidated lot:</Label>
                <FormikInputField type="select" name="consolidatedLotId">
                  <option>Select an existing consolidated lot</option>
                  {lots.map(l => (
                    <option key={l.id} value={l.id}>
                      {l.reference}
                    </option>
                  ))}
                </FormikInputField>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={onToggle}>
                Cancel
              </Button>{' '}
              <SubmissionButton
                color="primary"
                isSubmitting={submitting}
                onClick={async () => {
                  this.setSubmitting(true);

                  try {
                    await addToExistingConsolidatedLot({
                      variables: {
                        breweryId: brewery.id,
                        lotIds: lotTransfers.map(l => l.lot.id),
                        lotTransferIds: lotTransfers.map(l => l.id),
                        consolidatedLotId: values.consolidatedLotId
                      },
                      awaitRefetchQueries: true,
                      refetchQueries
                    });
                    onSuccess();
                  } catch (err) {
                    console.error(err);
                    this.setError('An unknown error occured');
                    this.setSubmitting(false);
                  }
                }}
              >
                Transfer
              </SubmissionButton>
            </ModalFooter>
          </Fragment>
        )}
      </Mutation>
    );
  }
}

export class CreateConsolidatedLotForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false
    };
  }

  setSubmitting = submitting => {
    this.setState({
      submitting
    });
  };

  setError = error => {
    this.setState({
      error
    });
  };

  render() {
    const { values, brewery, onSuccess, refetchQueries, firstLotProduct, lotTransfers, onToggle, tanks } = this.props;
    const { submitting } = this.state;
    return (
      <Mutation mutation={transferLotsToNewConsolidatedLot}>
        {transferLots => (
          <Fragment>
            <ModalBody>
              <div>
                <p>
                  There are no consolidated lots in progress for <em>{firstLotProduct.lot.product.name}</em>. Would you
                  like to create one for these lots:
                </p>
                <div className="mb3 pt2 pb3 bb-divider">
                  {lotTransfers.map(t => (
                    <h4 key={t.id} className="mv0 mb2 f5">
                      {t.lot.reference}
                    </h4>
                  ))}
                </div>
                <div className="mb3">
                  <Label>Tank:</Label>
                  <FormikInputField type="select" name="tankId">
                    <option>Select an empty tank</option>
                    {tanks.map(t => (
                      <option key={t.id} value={t.id}>
                        {t.name}
                      </option>
                    ))}
                  </FormikInputField>
                </div>
                <div>
                  <Label>Transfer schedule:</Label>
                  <FormikInputField type="select" name="transferScheduleId">
                    <TransferScheduleOptions isConsolidated={true} />
                  </FormikInputField>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={onToggle}>
                Cancel
              </Button>{' '}
              <SubmissionButton
                color="primary"
                isSubmitting={submitting}
                onClick={async () => {
                  this.setSubmitting(true);

                  try {
                    await transferLots({
                      variables: {
                        breweryId: brewery.id,
                        lotIds: lotTransfers.map(l => l.lot.id),
                        lotTransferIds: lotTransfers.map(l => l.id),
                        tankId: values.tankId,
                        transferScheduleId: values.transferScheduleId
                      },
                      awaitRefetchQueries: true,
                      refetchQueries
                    });
                    onSuccess();
                  } catch (err) {
                    console.error(err);
                    this.setError('An unknown error occured');
                    this.setSubmitting(false);
                  }
                }}
              >
                Create and transfer
              </SubmissionButton>
            </ModalFooter>
          </Fragment>
        )}
      </Mutation>
    );
  }
}

export class TransferToUniTankModal extends Component {
  getLotProductDetails = () => {
    const grouped = groupBy(this.props.lotTransfers, l => l.lot.product.id);
    return Object.keys(grouped).map(k => grouped[k][0]);
  };

  renderCreateConsolidatedLot = (firstLotProduct, data) => {
    return (
      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={async (values, { setErrors, setSubmitting }) => {}}
        render={props => {
          return <CreateConsolidatedLotForm {...props} {...this.props} firstLotProduct={firstLotProduct} {...data} />;
        }}
      />
    );
  };

  renderUseExistingConsolidatedLot = (firstLotProduct, data) => {
    return (
      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={async (values, { setErrors, setSubmitting }) => {}}
        render={props => {
          return (
            <UseExistingConsolidatedLotForm {...props} {...this.props} firstLotProduct={firstLotProduct} {...data} />
          );
        }}
      />
    );
  };

  getRequiresDutyPaid = lotTransfers => {
    // If any of the transfers have `requiresDutyPaid` and any of the associated lots don't have duty paid,
    // return true
    const atLeastOneRequiresDuty = this.props.lotTransfers.some(l => l.requiresDutyPaid);
    if (!atLeastOneRequiresDuty) {
      return [];
    }
    const lotsThatRequireDuty = this.props.lotTransfers.filter(l => !l.lot.dutyPaid);
    return lotsThatRequireDuty;
  };

  renderRequiresDutyPaid = lotTransfers => {
    return (
      <Fragment>
        <ModalBody>
          <div>
            <p>
              This transfer requires the corresponding lots to first have duty paid. Please confirm that duty has been
              paid on these lots before confirming this transfer to uni tank:
            </p>
            <div className="mb3 pt2 pb3 bb-divider">
              {lotTransfers.map(t => (
                <h4 className="mv0 mb2 f5">
                  <Link to={`/lots/${t.lot.id}`}>{t.lot.reference}</Link>
                </h4>
              ))}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.props.onToggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Fragment>
    );
  };

  renderInner = () => {
    if (!this.props.isOpen) {
      return null;
    }

    const lotProducts = this.getLotProductDetails();
    if (lotProducts.length > 1) {
      return (
        <div className="pv3 ph4">
          <p>
            You can't transfer different products into the same tank. Please select transfers that all have the same
            product
          </p>
        </div>
      );
    }

    const firstLotProduct = lotProducts[0];
    return (
      <Query
        query={getLotsAndUniTanks}
        fetchPolicy="network-only"
        variables={{
          breweryId: this.props.brewery.id,
          productId: firstLotProduct.lot.product.id,
          isConsolidated: true
        }}
      >
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return (
              <div className="items-center flex justify-center">
                <Loader className="pa4" />
              </div>
            );
          }

          if (error) {
            return <p className="pa4">Sorry, there was an error getting the uni tanks for transfer</p>;
          }

          const lotTransersThatRequireDuty = this.getRequiresDutyPaid();
          if (lotTransersThatRequireDuty.length) {
            return this.renderRequiresDutyPaid(lotTransersThatRequireDuty);
          }

          if (!data.lots.length) {
            return this.renderCreateConsolidatedLot(firstLotProduct, data);
          }

          return this.renderUseExistingConsolidatedLot(firstLotProduct, data);
        }}
      </Query>
    );
  };

  render() {
    const { isOpen, onToggle } = this.props;
    return (
      <Modal isOpen={isOpen} toggle={onToggle}>
        <ModalHeader toggle={onToggle}>Transfer to uni tank</ModalHeader>
        {this.renderInner()}
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery,
    upcomingBrewCustomsReport: state.brewery.country.upcomingBrewCustomsReport
  };
}
export default connect(mapStateToProps)(TransferToUniTankModal);



// WEBPACK FOOTER //
// ./src/containers/transferToUniTankModal/transferToUniTankModal.jsx